// src/app/user-settings/font-size.util.ts
export type FontSizeKey = 'browser' | 'small' | 'medium' | 'large' | 'extra-large';
export const FONT_SIZE_STORAGE_KEY = 'app_font_size';

export function applyFontSizeByKey(size: FontSizeKey) {
  if (size === 'browser') {
    document.documentElement.style.removeProperty('font-size');
    return;
  }
  document.documentElement.style.fontSize =
    size === 'small'       ? '12px' :
    size === 'large'       ? '18px' :
    size === 'extra-large' ? '22px' :
                              '14px';
}
